/**
 * Reducers index
 */
/* eslint-disable quote-props */
import { combineReducers, Reducer } from 'redux';
import { routerReducer } from '@angular-redux/router';

import { uiReducer, IUiState } from './ui';
import { userSessionReducer, IUserSession } from './session';
import { notificationsReducer, INotificationsState } from './notifications';
import { IToolsState, toolsReducer } from './tools';
import { entityReducer } from './entities-api/entities-api-reducer';
import { IBaseState } from './base-reducer';
import { eventsReducer, IEventState } from '@store/reducers/events';
import {
  IStoreState,
  storesReducer,
} from '@store/reducers/stores/stores.reducer';
import { preferencesReducer, PreferencesState } from './preferences';
import { XuxDndCacheState } from '@app/store/reducers/dashboard-cache/xux-dnd-cache.type';
import { xuxDndCacheReducer } from '@app/store/reducers/dashboard-cache/xux-dnd-cache.reducer';

/**
 * IAction interface
 */
export interface IAction {
  type: string;
  payload?: any;
}

/**
 * ActionReducer interface
 */
export type ActionReducer<T> = (state: T, action: IAction) => T;

/**
 * Application state interface
 */
export interface IAppState {
  router?: string;
  notifications?: INotificationsState;
  ui?: IUiState;
  entities?: {
    [entityName: string]: IBaseState;
  };
  userSession?: IUserSession;
  tools?: IToolsState;
  events?: IEventState;
  stores?: IStoreState;
  preferences?: PreferencesState;
  xuxDndCache?: XuxDndCacheState;
}

/**
 * Root reducer
 */
export const rootReducer: Reducer<IAppState> = combineReducers<IAppState>({
  userSession: userSessionReducer,
  router: routerReducer,
  ui: uiReducer,
  tools: toolsReducer,
  notifications: notificationsReducer,
  entities: entityReducer,
  events: eventsReducer,
  stores: storesReducer,
  preferences: preferencesReducer,
  xuxDndCache: xuxDndCacheReducer,
});
